<script setup lang="ts">
import type { ApiImage } from '~/types/blocks';

defineProps<{
  image: ApiImage;
  alt?: string;
  width?: number;
  height?: number;
  loading?: 'lazy' | 'eager';
  sizes?: string;
}>();
</script>

<template>
  <NuxtImg
    :src="toCmsMediaPath(image.url)"
    :alt="alt ?? ''"
    :width="width ?? image.width"
    :height="height ?? image.height"
    :loading="loading ?? 'lazy'"
    :sizes="sizes"
    class="object-cover"
  />
</template>
